<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12">
      <p-table #dt
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [filterDelay]="0"
        [loading]="administratorService.loading"
        [paginator]="true"
        [rows]="10"
        [rowHover]="true"
        [rowsPerPageOptions]="[10, 25, 50]"
        [showCurrentPageReport]="true" 
        [value]="administratorService.administrators"
        pDroppable="row">
        
        <ng-template pTemplate="caption">
          <div class="container-fluid">
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                Administradores
              </div>
              <div class="col-8 text-end">

                <div class="d-inline-block" ngbDropdown>
                  <button
                    type="button"
                    class="btn btn-success me-2"
                    ngbDropdownToggle>
                    Agregar
                  </button>
                  <div ngbDropdownMenu>
                    <button 
                      (click)="create()"
                      ngbDropdownItem>
                      Vincular usuario
                    </button>
                  </div>
                </div>

                <button (click)="administratorService.getAll(neighborhoodId!)" class="btn btn-primary rounded-circle me-2">
                  <i class="material-icons mt-1">refresh</i>
                </button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>

            @if(authService.currentUser?.profile == "sudo") {
              <th pSortableColumn="uid">
                UID
                <p-sortIcon field="uid"></p-sortIcon>
                <p-columnFilter type="text" field="uid" display="menu"></p-columnFilter>
              </th>
            }

            <th pSortableColumn="email">
              Email
              <p-sortIcon field="email"></p-sortIcon>
              <p-columnFilter type="text" field="email" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="fullName">
              Nombre
              <p-sortIcon field="fullName"></p-sortIcon>
              <p-columnFilter type="text" field="fullName" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="isOwner">
              Dueño del fraccionamiento
              <p-sortIcon field="isOwner"></p-sortIcon>
              <p-columnFilter type="boolean" field="isOwner" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="paymentsNotification">
              Notificar pagos
              <p-sortIcon field="paymentsNotification"></p-sortIcon>
              <p-columnFilter type="boolean" field="paymentsNotification" display="menu"></p-columnFilter>
            </th>

            <th pSortableColumn="reportsNotification">
              Notificar reportes
              <p-sortIcon field="reportsNotification"></p-sortIcon>
              <p-columnFilter type="boolean" field="reportsNotification" display="menu"></p-columnFilter>
            </th>

            <th>Acciones</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-administrator>
          
          <tr class="p-selectable-row">

            @if(authService.currentUser?.profile == "sudo") {
              <td>
                <span class="p-column-title">UID</span>
                {{ administrator.uid }}
              </td>
            }

            <td>
              <span class="p-column-title">Email</span>
              {{ administrator.email }}
            </td>

            <td>
              <span class="p-column-title">Nombre</span>
              {{ administrator.fullName }}
            </td>

            <td>
              <span class="p-column-title">Dueño del fraccionamiento</span>
              <p-inputSwitch
                (onChange)="update(administrator)"
                [(ngModel)]="administrator.isOwner">
              </p-inputSwitch>
            </td>

            <td>
              <span class="p-column-title">Notificar pagos</span>
              <p-inputSwitch
                (onChange)="update(administrator)"
                [(ngModel)]="administrator.paymentsNotification">
              </p-inputSwitch>
            </td>

            <td>
              <span class="p-column-title">Notificar reportes</span>
              <p-inputSwitch
                (onChange)="update(administrator)"
                [(ngModel)]="administrator.reportsNotification">
              </p-inputSwitch>
            </td>

            <td>
              <button
                (click)="open(administrator)"
                class="btn btn-sm btn-light rounded-circle me-2">
                <i class="material-icons mt-1">more_vert</i>
              </button>

              <button 
                (click)="delete(administrator)"
                class="btn btn-sm btn-danger rounded-circle">
                <i class="material-icons mt-1">delete</i>
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
